import { styled } from '@linaria/react';
import { motion } from 'framer-motion';

import { range } from '@/utils';
import { DemoSliderControl } from '@/components/Demo';

import GridDemo from './GridDemo';
import Item from './Item';
import { GridStructure } from './Grid.shared';

function ImplicitGrid() {
  return (
    <GridDemo
      initialValues={{
        numOfChildren: 3,
      }}
      customGrid={{
        gridTemplateColumns: '1fr',
      }}
      controls={[
        <SliderWrapper key="numOfChildren">
          <DemoSliderControl
            id="numOfChildren"
            label="Number of Children"
            min={1}
            max={5}
            step={1}
            handleFocusColor="white"
            wrapperStyle={{
              width: 400,
              maxWidth: '80vw',
            }}
          />
        </SliderWrapper>,
      ]}
    >
      {({ numOfChildren, isPerspectiveEnabled }) => {
        return (
          <OuterWrapper>
            <Wrapper>
              <BackLayer
                style={{
                  transform: isPerspectiveEnabled
                    ? 'translateX(10%) skewY(18deg) scaleX(0.85)'
                    : 'translateX(0%) skewY(0deg) scaleX(1)',
                }}
              >
                <GridStructure>
                  {range(numOfChildren).map((index) => (
                    <GridTrack key={index} />
                  ))}
                </GridStructure>
              </BackLayer>
              <Layer
                style={{
                  transform: isPerspectiveEnabled
                    ? 'translateX(-10%) skewY(18deg) scaleX(0.85)'
                    : 'translateX(0%) skewY(0deg) scaleX(1)',
                }}
              >
                <ChildWrapper>
                  {range(numOfChildren).map((index) => (
                    <Item
                      key={index}
                      layout={false}
                      style={{
                        opacity: isPerspectiveEnabled ? 0.8 : 1,
                        height: 50,
                      }}
                    />
                  ))}
                </ChildWrapper>
              </Layer>
            </Wrapper>
          </OuterWrapper>
        );
      }}
    </GridDemo>
  );
}

const SliderWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
`;

const OuterWrapper = styled.div`
  margin: 64px auto;
  width: 100%;
  max-width: 350px;
`;

const Wrapper = styled.div`
  position: relative;
`;

const Layer = styled(motion.div)`
  transition: transform 500ms;
  will-change: transform;
`;

const BackLayer = styled(Layer)`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
`;

const ChildWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  gap: 2px;
  padding: 2px;
`;

const GridTrack = styled.div`
  border: 1px solid transparent;
  height: 56px;

  &:not(:last-of-type) {
    border-bottom: 2px dashed var(--color-gray-500);
  }
`;

export default ImplicitGrid;
